import React, { useState, useEffect } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import ContactList from './components/ContactList';
import ConversationArea from './components/ConversationArea';
import ParticipantPanel from './components/ParticipantPanel';

import Button from '../../components/ui/Button';

const LiveChatCommunicationHub = () => {
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [isParticipantPanelOpen, setIsParticipantPanelOpen] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [roleFilter, setRoleFilter] = useState('all');
  const [conversations, setConversations] = useState([]);
  const [messages, setMessages] = useState({});
  const [typingUsers, setTypingUsers] = useState({});

  const mockConversations = [
  {
    id: 1,
    type: 'direct',
    name: 'Rahul Sharma',
    role: 'student',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11c45223e-1763291832973.png",
    avatarAlt: 'Professional headshot of young Indian man in formal attire',
    isOnline: true,
    lastMessage: 'Thanks for the interview opportunity!',
    lastMessageTime: '2 min ago',
    unreadCount: 2,
    lastActive: new Date()
  },
  {
    id: 2,
    type: 'direct',
    name: 'Tech Innovations HR',
    role: 'employer',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f51cac9e-1766582635935.png",
    avatarAlt: 'Tech Innovations company logo with blue gradient background',
    isOnline: true,
    lastMessage: 'We would like to schedule an interview',
    lastMessageTime: '10 min ago',
    unreadCount: 0,
    lastActive: new Date()
  },
  {
    id: 3,
    type: 'group',
    name: 'Campus Recruitment 2026',
    role: 'institution',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14256b291-1764684278019.png",
    avatarAlt: 'Group chat icon with multiple user silhouettes',
    isOnline: false,
    lastMessage: 'Priya: The placement drive starts next week',
    lastMessageTime: '1 hour ago',
    unreadCount: 5,
    participants: 12,
    lastActive: new Date(Date.now() - 3600000)
  },
  {
    id: 4,
    type: 'direct',
    name: 'Priya Patel',
    role: 'student',
    avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1ee2bcef3-1763301295581.png',
    avatarAlt: 'Professional portrait of young woman with long dark hair',
    isOnline: false,
    lastMessage: 'Can you share the job description?',
    lastMessageTime: '3 hours ago',
    unreadCount: 0,
    lastActive: new Date(Date.now() - 10800000)
  },
  {
    id: 5,
    type: 'group',
    name: 'Software Development Team',
    role: 'employer',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_12190816b-1766529780236.png",
    avatarAlt: 'Team collaboration icon with orange background',
    isOnline: true,
    lastMessage: 'Amit: Project deadline extended to Friday',
    lastMessageTime: '5 hours ago',
    unreadCount: 0,
    participants: 8,
    lastActive: new Date(Date.now() - 18000000)
  },
  {
    id: 6,
    type: 'direct',
    name: 'StartupHub Technologies',
    role: 'employer',
    avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1ca89a7b3-1764635718024.png',
    avatarAlt: 'StartupHub Technologies logo featuring orange rocket icon',
    isOnline: false,
    lastMessage: 'Your application has been shortlisted',
    lastMessageTime: '1 day ago',
    unreadCount: 0,
    lastActive: new Date(Date.now() - 86400000)
  },
  {
    id: 7,
    type: 'direct',
    name: 'Sneha Reddy',
    role: 'student',
    avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_12672b149-1763294392419.png',
    avatarAlt: 'Professional headshot of woman with confident smile',
    isOnline: true,
    lastMessage: 'Looking forward to the interview tomorrow',
    lastMessageTime: '2 days ago',
    unreadCount: 0,
    lastActive: new Date()
  },
  {
    id: 8,
    type: 'group',
    name: 'Institution Coordinators',
    role: 'institution',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11308bc5c-1770151026652.png",
    avatarAlt: 'Institution building icon with green background',
    isOnline: false,
    lastMessage: 'Meeting scheduled for Monday 10 AM',
    lastMessageTime: '3 days ago',
    unreadCount: 0,
    participants: 15,
    lastActive: new Date(Date.now() - 259200000)
  }];


  const mockMessages = {
    1: [
    {
      id: 1,
      senderId: 1,
      senderName: 'Rahul Sharma',
      senderAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11c45223e-1763291832973.png",
      senderAvatarAlt: 'Professional headshot of young Indian man',
      content: 'Hello! I wanted to follow up on my application for the Frontend Developer position.',
      timestamp: new Date(Date.now() - 7200000),
      status: 'read',
      type: 'text'
    },
    {
      id: 2,
      senderId: 'me',
      senderName: 'You',
      content: 'Hi Rahul! Thanks for reaching out. We reviewed your application and are impressed with your portfolio.',
      timestamp: new Date(Date.now() - 7000000),
      status: 'read',
      type: 'text'
    },
    {
      id: 3,
      senderId: 1,
      senderName: 'Rahul Sharma',
      senderAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11c45223e-1763291832973.png",
      senderAvatarAlt: 'Professional headshot of young Indian man',
      content: 'That\'s great to hear! When can I expect to hear about the next steps?',
      timestamp: new Date(Date.now() - 6800000),
      status: 'read',
      type: 'text'
    },
    {
      id: 4,
      senderId: 'me',
      senderName: 'You',
      content: 'We would like to schedule a technical interview with you. Are you available this Thursday or Friday?',
      timestamp: new Date(Date.now() - 6600000),
      status: 'read',
      type: 'text'
    },
    {
      id: 5,
      senderId: 1,
      senderName: 'Rahul Sharma',
      senderAvatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1ef2015b3-1763301538793.png',
      senderAvatarAlt: 'Professional headshot of young Indian man',
      content: 'Thanks for the interview opportunity!',
      timestamp: new Date(Date.now() - 120000),
      status: 'delivered',
      type: 'text'
    }],

    2: [
    {
      id: 1,
      senderId: 2,
      senderName: 'Tech Innovations HR',
      senderAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1164ea2cf-1770151025774.png",
      senderAvatarAlt: 'Tech Innovations company logo',
      content: 'Good morning! We have reviewed your profile and would like to move forward with your application.',
      timestamp: new Date(Date.now() - 1800000),
      status: 'read',
      type: 'text'
    },
    {
      id: 2,
      senderId: 2,
      senderName: 'Tech Innovations HR',
      senderAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1164ea2cf-1770151025774.png",
      senderAvatarAlt: 'Tech Innovations company logo',
      content: 'We would like to schedule an interview',
      timestamp: new Date(Date.now() - 600000),
      status: 'delivered',
      type: 'text'
    }],

    3: [
    {
      id: 1,
      senderId: 3,
      senderName: 'Dr. Amit Kumar',
      senderAvatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1a7d4290a-1763293336648.png',
      senderAvatarAlt: 'Professional photo of man in business casual attire',
      content: 'Welcome everyone to the Campus Recruitment 2026 group!',
      timestamp: new Date(Date.now() - 86400000),
      status: 'read',
      type: 'text'
    },
    {
      id: 2,
      senderId: 4,
      senderName: 'Priya Patel',
      senderAvatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1ee2bcef3-1763301295581.png',
      senderAvatarAlt: 'Professional portrait of young woman',
      content: 'The placement drive starts next week',
      timestamp: new Date(Date.now() - 3600000),
      status: 'read',
      type: 'text'
    }]

  };

  useEffect(() => {
    setConversations(mockConversations);
    setMessages(mockMessages);
  }, []);

  useEffect(() => {
    if (selectedConversation) {
      const timer = setTimeout(() => {
        setTypingUsers((prev) => ({ ...prev, [selectedConversation?.id]: false }));
      }, 3000);

      const typingTimer = setTimeout(() => {
        if (Math.random() > 0.7) {
          setTypingUsers((prev) => ({ ...prev, [selectedConversation?.id]: true }));
        }
      }, 5000);

      return () => {
        clearTimeout(timer);
        clearTimeout(typingTimer);
      };
    }
  }, [selectedConversation]);

  const filteredConversations = conversations?.filter((conv) => {
    const matchesSearch = conv?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesRole = roleFilter === 'all' || conv?.role === roleFilter;
    return matchesSearch && matchesRole;
  });

  const handleSelectConversation = (conversation) => {
    setSelectedConversation(conversation);
    setConversations((prev) =>
    prev?.map((conv) =>
    conv?.id === conversation?.id ? { ...conv, unreadCount: 0 } : conv
    )
    );
  };

  const handleSendMessage = (content, type = 'text') => {
    if (!selectedConversation || !content?.trim()) return;

    const newMessage = {
      id: Date.now(),
      senderId: 'me',
      senderName: 'You',
      content: content?.trim(),
      timestamp: new Date(),
      status: 'sent',
      type
    };

    setMessages((prev) => ({
      ...prev,
      [selectedConversation?.id]: [...(prev?.[selectedConversation?.id] || []), newMessage]
    }));

    setConversations((prev) =>
    prev?.map((conv) =>
    conv?.id === selectedConversation?.id ?
    { ...conv, lastMessage: content, lastMessageTime: 'Just now' } :
    conv
    )
    );

    setTimeout(() => {
      setMessages((prev) => ({
        ...prev,
        [selectedConversation?.id]: prev?.[selectedConversation?.id]?.map((msg) =>
        msg?.id === newMessage?.id ? { ...msg, status: 'delivered' } : msg
        )
      }));
    }, 1000);

    setTimeout(() => {
      setMessages((prev) => ({
        ...prev,
        [selectedConversation?.id]: prev?.[selectedConversation?.id]?.map((msg) =>
        msg?.id === newMessage?.id ? { ...msg, status: 'read' } : msg
        )
      }));
    }, 3000);
  };

  return (
    <MainLayout>
      <div className="flex flex-col h-[calc(100vh-12rem)]">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-3xl font-bold text-foreground">Live Chat & Communication Hub</h1>
            <p className="text-muted-foreground mt-1">Real-time messaging for students, employers, and institutions</p>
          </div>
          <div className="flex gap-2">
            <Button iconName="MessageSquarePlus" variant="default">
              New Chat
            </Button>
            <Button iconName="Users" variant="outline">
              Create Group
            </Button>
          </div>
        </div>

        <div className="flex-1 grid grid-cols-1 lg:grid-cols-12 gap-4 overflow-hidden">
          <div className="lg:col-span-3 bg-card border border-border rounded-lg overflow-hidden flex flex-col">
            <ContactList
              conversations={filteredConversations}
              selectedConversation={selectedConversation}
              onSelectConversation={handleSelectConversation}
              searchQuery={searchQuery}
              onSearchChange={setSearchQuery}
              roleFilter={roleFilter}
              onRoleFilterChange={setRoleFilter} />

          </div>

          <div className={`${isParticipantPanelOpen ? 'lg:col-span-6' : 'lg:col-span-9'} bg-card border border-border rounded-lg overflow-hidden flex flex-col`}>
            <ConversationArea
              conversation={selectedConversation}
              messages={messages?.[selectedConversation?.id] || []}
              onSendMessage={handleSendMessage}
              isTyping={typingUsers?.[selectedConversation?.id]}
              onToggleParticipantPanel={() => setIsParticipantPanelOpen(!isParticipantPanelOpen)} />

          </div>

          {isParticipantPanelOpen && selectedConversation &&
          <div className="lg:col-span-3 bg-card border border-border rounded-lg overflow-hidden">
              <ParticipantPanel conversation={selectedConversation} />
            </div>
          }
        </div>
      </div>
    </MainLayout>);

};

export default LiveChatCommunicationHub;